<div class="tw-w-full tw-min-h-[calc(100vh-186px)] tw-flex tw-flex-col tw-items-center tw-justify-center tw-font-body tw-bg-gray-100 tw-pb-[260px]">
  <div class="tw-h-max tw-font-lexend">
    <img class="tw-mx-auto tw-w-20 tw-h-20 tw-mb-4" [src]="iconSrc()" [class]="iconClass()" alt="icon"/>
    <ng-content></ng-content>
  </div>
</div>
